import React from 'react';
import styled from 'styled-components';
import useContentModeradora from '../hooks/parameter/useContentModeradora.js';

const DivContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;

  p {
    text-align: center;

    img {
      margin-top: 2.5rem;
      width: 100% !important;
    }
  }
`;

export const PageCuota = () => {
  window.scroll(0, 0);
  const { contentModeradora } = useContentModeradora();

  const bodyHTML =
    contentModeradora.length > 0 && contentModeradora[0].texto_completo;

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <DivContainer id='contBodyHTML'>
          <p dangerouslySetInnerHTML={{ __html: bodyHTML }} />
        </DivContainer>
      </div>
    </>
  );
};
